import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FileSaverService } from 'ngx-filesaver';
import { map, Observable, Subscription } from 'rxjs';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { NgStyle, AsyncPipe } from '@angular/common';
import { SpinnerComponent } from '@spartacus/storefront';
@Component({
    selector: 'knbr-kn-br-find-my-contact-search-result',
    templateUrl: './kn-br-find-my-contact-search-result.component.html',
    styleUrl: './kn-br-find-my-contact-search-result.component.scss',
    imports: [
        NgStyle,
        SpinnerComponent,
        AsyncPipe,
    ],
})
export class KnBrFindMyContactSearchResultComponent implements OnInit, OnDestroy {
  contactInfo$: Observable<any> = this.knbrcommonservice.loadContactInfo$();
  searchTriggered$ = this.knbrcommonservice.loadSearchTriggered$();
  contactDataLoading$ = this.knbrcommonservice.findMyContactPageLoading$;
  brandColors: Record<string, string> = {
    carlisle: '#00509e',
    versico: '#FCC52B',
    weatherbond: '#E8793D',
    hunter: '#005954',
    henry: '#0090D2',
    petersen : '#5278DC',
    drexel: '#003591',
    citadel: '#007DC8',
  };

  /* brandColors: Record<string, string> = {
     '0060_18_00': '#005954',
     '0160_18_00': '#005954',
     '0020_18_00': '#FCC52B',
     '0010_10_00': '#00509e',
     '0100_10_00': '#00509e',
     '0060_50_00': '#005954',
     '0160_50_00': '#005954',
     '0021_21_00': '#E8793D',
     '0101_21_00': '#E8793D',
     Henry: '#0090D2',
   };*/
  result = [];
  FMC_Role;
  allSubscriptions = new Subscription();
  contactsWithColors$;
  hoverIndex = -1;
  hoverIndex2 = -1;
  totalItems = [];
  constructor(
    private fileSaverService: FileSaverService,
    private knbrcommonservice: KnBrCommonService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.knbrcommonservice.fmcRoleData$.subscribe((response: any) => {
      if (response) {
        this.FMC_Role = this.createRoleMap(response);
      }
    });
    this.knbrcommonservice.brandList$.subscribe((response: any) => {
      if (response) {
        this.result = Object?.keys(response).map((key) => ({ name: response[key], value: key }));
      }
    });
    this.contactsWithColors$ = this.contactInfo$.pipe(
      map((contacts) => {
        const safeContacts = contacts ?? [];

        return safeContacts.map((contact) => {
          const brandName = this.getBrandName(contact.brandId);
          const brandColor = this.getBrandColor(brandName);
          // Precompute hover style
          const hoverStyle = {
            brandColor,
            'background-color': brandColor + '1A', // 10% opacity to existing color
            border: `1px solid ${brandColor}4D`,
          };
          // Precompute contact hover style
          /* const hoverContactStyle = {
             'background-color': brandColor + '1A', // 10% opacity
             border: `1px solid ${brandColor}4D`   // 30% opacity
           };*/

          return { ...contact, brandName, brandColor, hoverStyle };
        });
      })
    );
  }

  createRoleMap(data: string[]): Record<string, { name: string; order: number }> {
    return Object.fromEntries(
      data.map((item, index) => {
        const [id, name] = item.split(':');
        return [id, { name, order: index }];
      })
    );
  }

  downloadCard(cardSection: HTMLElement): void {
    cardSection.classList.add('pdf-mode');

    const SCALE = 2;

    html2canvas(cardSection, {
      scale: SCALE,
      useCORS: true,
      backgroundColor: '#ffffff',
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');

      // Create A4 PDF
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      //Margins (mm)
      const marginX = 15;
      const marginTop = 8;
      const marginBottom = 12;

      const usableWidth = pageWidth - marginX * 2;
      const usableHeight = pageHeight - marginTop - marginBottom;

      // Convert canvas px → mm
      const pxToMm = (px: number) => px * 0.264583;

      let imgWidthMm = pxToMm(canvas.width);
      let imgHeightMm = pxToMm(canvas.height);

      // Fit image inside usable area
      const scaleFactor = Math.min(usableWidth / imgWidthMm, usableHeight / imgHeightMm);

      imgWidthMm *= scaleFactor;
      imgHeightMm *= scaleFactor;

      // Center image inside margins
      const x = marginX + (usableWidth - imgWidthMm) / 2;
      const y = marginTop;

      pdf.addImage(imgData, 'PNG', x, y, imgWidthMm, imgHeightMm);

      // for downloading
      const blob = pdf.output('blob');
      this.fileSaverService.save(blob, 'contact-card-download.pdf');

      cardSection.classList.remove('pdf-mode');
    });
  }

  getBrandColor(brand: string): string {
    let getBrandFirstWord = brand?.trim().split(/\s+/)[0].toLowerCase();
    return this.brandColors[getBrandFirstWord] || '#f0f0f0'; // default color
  }

  getBrandName(brandId: string): string {
    for (let num of this.result) {
      if (brandId == num.value) {
        return num.name;
      }
    }
  }

  /*getRoleBadgeStyles(brandId: string) {
    const color = this.getBrandColor(brandId);
    return {
      color,
      'background-color': color + '1A', // 10% opacity to existing color
      border: `1px solid ${color}4D`, // 30% opacity to existing color
    };
  }
  hoverIndex = -1;
  hoverIndex2 = -1;
  getContactHoverStyles(brandId: string) {
    const color = this.getBrandColor(brandId);;

    return {
      'background-color': color + '1A', // 10% opacity to existing color
      border: `1px solid ${color}4D` // 30% opacity to existing color
    };
  }*/
  getFMC_RoleName(roleId: string) {
    return this.FMC_Role[roleId]?.name || '';
  }

  getSortedContactRoles(roles: any[]) {
    if (!roles || !this.FMC_Role) return roles;

    return [...roles].sort((a, b) => {
      const orderA = this.FMC_Role[a.id]?.order ?? 999;
      const orderB = this.FMC_Role[b.id]?.order ?? 999;
      return orderA - orderB;
    });
  }

  ngOnDestroy(): void {
    this.knbrcommonservice.searchTriggered$.next(false);
    this.allSubscriptions?.unsubscribe();
  }
}
